import { FC, useEffect, useState, useRef } from 'react';
import { Link, useRouteMatch, useHistory } from 'react-router-dom';
import useSwr from 'swr';
import toast from 'react-hot-toast';
import cn from 'clsx';
import { fetchIdea } from '@utils/Poll';
import { useAuth } from '@hooks/Auth';
import Card from '@components/elements/Card';
import Chart from 'react-apexcharts';
import { format } from 'date-fns';
import ic_arr from '@images/right-arrow-long.png';
import ButtonMighty from '@components/elements/ButtonMighty';
import HeaderImage from '@components/elements/HeaderImage';
import Embed from '@components/elements/Embed';
import PeriodTimeline from '@components/elements/Period/Timeline';
import PollShareCard from '@components/modules/PollShareCard';
import PollOptionsForm from '@components/modules/Poll/PollOptionsForm';
import Logo from '@images/logo.png';
import './detail.css';

import '../Poll/PollDetailPage.css';
import { isFuture, isPast, isWithinInterval } from 'date-fns';
import { CompanyRole } from '@sdk/API';
import InputText from '@components/elements/InputText';
import Loader from '@components/elements/Loader';

import { useGlobalContext } from '@context/customContext';
import defaultTheme from '@theme/defaultTheme';
import kidsTheme from '@theme/kidsTheme';
import hipsterTheme from '@theme/hipsterTheme';
import professionalTheme from '@theme/professionalTheme';
import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PollQuestionCard from '@components/modules/Poll/QuestionCard';
import PollOptionCard from '@components/elements/PollOptionCard';
import {
  chargeIdeaPledge,
  getIdeaPledgeStripeChargeByUser,
} from '@sdk/managers/PaymentManager';
import { startCase, forEach } from 'lodash';
import Notice from '@components/elements/Notice';
import InputTextarea from '@components/elements/InputTextarea';
import { createComment } from '@sdk/managers/IdeaManager';
import { resourceUsage } from 'process';
import { styled } from '@mui/system';
import { getGuestData } from '@sdk/managers/UsersManager';

const THEMES = ['default', 'kids', 'hipster', 'professional'];
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUB_KEY ||
    'pk_test_51Iffk1IXx2HzzlEOIl2w2tJmhcSXOuitzV7SAkJaqi3aqRKOcOi2ElHYBR5YRT1ESJv4NsKvhTYBNSPnYEPcdQ6G00MG5sbPSM'
);

const randomColors = [
  '#2EFFE4',
  '#FF46FF',
  '#FFB400',
  '#FF2300',
  '#FFFF00',
  '#8401FF',
  '#28FF2F',
].filter((item) => item !== localStorage.getItem('randomColor'))[
  Math.floor(Math.random() * (localStorage.getItem('randomColor') ? 6 : 7))
];
localStorage.setItem('randomColor', randomColors);
const COLORS = [
  'yellow',
  'magenta',
  'orange',
  'green',
  'blue-light',
  'salmon',
  'purple',
  'yellow',
  'red-pastel',
];

const PollDetailPage: FC = () => {
  const history = useHistory();
  const {
    url,
    params: { pollId },
  } = useRouteMatch<{
    pollId: string;
  }>();

  const { user, dbUser, company, loading } = useAuth();
  const [auth, setAuth] = useState<boolean>(true);
  const [password, setPassword] = useState<string>('');
  const stripe = useStripe();
  const elements = useElements();
  const [passwordError, setPasswordError] = useState<string>();
  const [isThemeCompany, setIsThemeCompany] = useState<boolean>(false);
  const [voteCount, setVoteCount] = useState(0);
  const [isSubmitting, setSubmitting] = useState(false);
  const { themeData, setThemeData, customTheme, setGuest, guest } =
    useGlobalContext();
  const [coupon, setCoupon] = useState('');

  const [textComment, setTextComment] = useState('');
  const [commenting, setCommenting] = useState(false);
  const [select, setSelect] = useState<any>();
  let { data, error } = useSwr(
    pollId && loading === false ? [pollId] : null,
    fetchIdea,
    {
      revalidateOnFocus: true,
    }
  );

  const RadaChart = () => {
    const score = data?.scores.items.reduce(
      (r, a) => {
        r.level_of_success = a.level_of_success + (r.level_of_success || 0);
        r.investment_required =
          a.investment_required + (r.investment_required || 0);
        r.talent_required = a.talent_required + (r.talent_required || 0);
        r.consultation_required =
          a.consultation_required + (r.consultation_required || 0);
        r.connection_required =
          a.connection_required + (r.connection_required || 0);
        return r;
      },
      {
        level_of_success: 0,
        talent_required: 0,
        investment_required: 0,
        consultation_required: 0,
        connection_required: 0,
      }
    );
    const dataChart = {
      series: [
        {
          data: [
            Math.floor(
              score.level_of_success / (data?.scores.items.length || 1)
            ),

            Math.floor(
              score.talent_required / (data?.scores.items.length || 1)
            ),
            Math.floor(
              score.investment_required / (data?.scores.items.length || 1)
            ),
            Math.floor(
              score.connection_required / (data?.scores.items.length || 1)
            ),
            Math.floor(
              score.consultation_required / (data?.scores.items.length || 1)
            ),
          ],
        },
      ],
      options: {
        chart: {
          type: 'radar',
          foreColor: 'white',
          toolbar: {
            show: true,
            tools: {
              download: false,
            },
          },
        },

        dataLabels: {
          enabled: true,
        },

        colors: ['#FF4560'],
        yaxis: {
          min: 0,
          max: 10,
          logBase: 5,
        },
        xaxis: {
          labels: {
            style: {
              fontSize: '16px',
            },
          },
          categories: [
            'Feasibility',
            ['Talent', 'required'],
            ['Investment', 'required'],
            ['Collaboration ', 'required'],
            ['Mentorship', 'required'],
          ],
        },
      } as any,
    };

    return (
      <div className="w-full flex flex-col items-center justify-center">
        <Chart
          options={dataChart.options}
          height={Math.min(window.screen.width - 80, 550)}
          series={dataChart.series}
          type="radar"
          width={Math.min(window.screen.width - 80, 600)}
        />
        <ol
          style={{
            color: 'white',

            listStyleType: 'decimal',
          }}
        >
          <li>
            <b>Feasibility:</b> A quick assessment of the practicality and
            likelihood of success for a given idea or project.
          </li>
          <li>
            <b>Investment Required:</b> An estimation of the financial resources
            needed to fund the development and implementation of an idea.
          </li>
          <li>
            <b>Talent Required:</b> Identification of the specific skills and
            expertise needed to execute and achieve the goals of an idea.
          </li>
          <li>
            <b>Collaboration Required:</b> Recognition of the need for
            cooperation and partnership with others to successfully realize an
            idea or project.
          </li>
          <li>
            <b>Mentorship Required:</b> Acknowledgment of the necessity for
            guidance and support from experienced individuals who can provide
            valuable insights and advice throughout the development process.
          </li>
        </ol>
      </div>
    );
  };
  const [statusObj, setStatusObj] = useState<any>({});
  const getStatusPledge = async () => {
    if (!dbUser?.id) return;
    const requests = data.pledges?.items.map(async (item) => {
      return await getIdeaPledgeStripeChargeByUser(item.id, dbUser?.id);
    });

    const res = await Promise.all(requests);
    const obj = (res || []).reduce((r: Record<string, any>, a: any) => {
      if (!!a) {
        r[a.ideaPledgeID] = a;
      }
      return r;
    }, {});
    setStatusObj(obj);
  };

  useEffect(() => {
    console.log(data, error);
    if (data && data !== 'NotFound') {
      getStatusPledge();
      const themeID = data.themeID || 'default';

      if (themeID && THEMES.includes(themeID)) {
        setIsThemeCompany(false);
        switch (themeID) {
          case 'default':
            setThemeData(defaultTheme);
            break;
          case 'kids':
            setThemeData(kidsTheme);
            break;
          case 'hipster':
            setThemeData(hipsterTheme);
            break;
          case 'professional':
            setThemeData(professionalTheme);
            break;
          default:
            setThemeData(defaultTheme);
            break;
        }
      }
      if (themeID && customTheme.id === themeID) {
        setIsThemeCompany(true);
        const tempTheme = { colors: { ...defaultTheme.colors } };
        if (customTheme) {
          const themeAttributes = customTheme.attributes;
          if (themeAttributes) {
            const {
              pollActivePeriodBgColor,
              pollActivePeriodShadowColor,
              pollQuestionCardBgColor,
              pollQuestionCardQuestionColor,
              pollQuestionCardAnswerColor,
              pollPledgeCastBtnTextColor,
              pollPledgeCastBtnBgColor,
              pollPledgeCastBtnBracketColor,
              pollPageBgColor,
            } = themeAttributes;
            tempTheme.colors['poll-period-active-bgColor'] =
              pollActivePeriodBgColor ||
              defaultTheme.colors['poll-period-active-bgColor'];
            tempTheme.colors['poll-period-active-shadowColor'] =
              pollActivePeriodShadowColor ||
              defaultTheme.colors['poll-period-active-shadowColor'];

            tempTheme.colors['poll-questionCard-bgColor'] =
              pollQuestionCardBgColor ||
              defaultTheme.colors['poll-questionCard-bgColor'];
            tempTheme.colors['poll-questionCard-question-color'] =
              pollQuestionCardQuestionColor ||
              defaultTheme.colors['poll-questionCard-question-color'];
            tempTheme.colors['poll-questionCard-answer-color'] =
              pollQuestionCardAnswerColor ||
              defaultTheme.colors['poll-questionCard-answer-color'];

            tempTheme.colors['poll-btnPledgeCastVote-textColor'] =
              pollPledgeCastBtnTextColor ||
              defaultTheme.colors['poll-btnPledgeCastVote-textColor'];
            tempTheme.colors['poll-btnPledgeCastVote-color'] =
              pollPledgeCastBtnBgColor ||
              defaultTheme.colors['poll-btnPledgeCastVote-color'];
            tempTheme.colors['poll-btnPledgeCastVote-borderColor'] =
              pollPledgeCastBtnBracketColor ||
              defaultTheme.colors['poll-btnPledgeCastVote-borderColor'];
            tempTheme.colors['poll-page-bgColor'] =
              pollPageBgColor || defaultTheme.colors['poll-page-bgColor'];

            setThemeData({ ...tempTheme });
          }
        }
      }
    }
    return () => {
      setThemeData({ ...defaultTheme });
    };
  }, [customTheme, data, setThemeData]);

  useEffect(() => {
    if (error) {
      toast.error(error.message || 'Failed to fetch idea information.');
      console.error({ error });
    }
  }, [error]);

  const checkScroll = () => {
    const el = window.document.getElementById('scrollView1');
    if (el) {
      return el.scrollHeight > el.offsetHeight;
    }
    return false;
  };

  const scrollTo = (type) => {
    const el = window.document.getElementById('scrollView1');
    if (el) {
      el.scrollTop += type === 'top' ? -40 : 40;
    }
  };
  const setUpGuestId = async () => {
    let guestId = '';
    const mightyPollGuest = localStorage.getItem('mighty_poll_guest');
    if (!mightyPollGuest) {
      const data: any = await getGuestData(new Date().valueOf().toString());
      localStorage.setItem(
        'mighty_poll_guest',
        (data && JSON.parse(data)?.id) || ''
      );
      setGuest((data && JSON.parse(data)?.id) || '');
      guestId = (data && JSON.parse(data)?.id) || '';
    }
    if (mightyPollGuest) {
      guestId = mightyPollGuest;
      setGuest(mightyPollGuest);
    }
    return guestId;
  };
  const comment = async () => {
    if (commenting || !textComment.length) return;
    setCommenting(true);
    try {
      var body;
      if (user) {
        body = {
          userID: dbUser?.id,
          name: dbUser?.username,
          ideaID: pollId,
          content: textComment,
        };
      } else {
        const guestId = await setUpGuestId();
        body = {
          userID: guestId,
          name: 'Guest',
          ideaID: pollId,
          content: textComment,
        };
      }
      const res = (await createComment(
        ['id', 'name', 'userID', 'ideaID', 'createdAt', 'content'],
        body
      )) as any;
      if (res?.data?.result) data.comments.items.unshift(res.data.result);
      console.log(res);
    } catch (error: any) {
      toast.error(error?.message || 'Failed to comment.');
    } finally {
      setTextComment('');
      setCommenting(false);
    }
  };

  const ownerPermission =
    user?.username === data?.owner ||
    (company &&
      company.companyID === data?.companyID &&
      (company?.role === CompanyRole.ADMIN ||
        company.role === CompanyRole.REPRESENTATIVE));

  // let bgColorBtnEditViewPoll = `${themeData.colors['detailPoll-btnViewEditPoll-color']}`;
  // let borderColorBtnEditViewPoll = `${themeData.colors['detailPoll-btnViewEditPoll-borderColor']}`;
  // let textColorBtnEditViewPoll = `${themeData.colors['detailPoll-btnViewEditPoll-textColor']}`;
  const pledges = async (event: any) => {
    event?.preventDefault();
    console.log('submit');

    if (!dbUser) return history.push('/login');
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      console.log('Stripe not loaded yet');
      return;
    }

    setSubmitting(true);

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    if (cardElement) {
      const result = await stripe.createToken(cardElement);

      if (result.error) {
        console.log('[error]', result.error);
        toast.error(result.error.message || 'Failed to use card.');
      } else if (!result) {
        toast.error('Failed to use card.');
      } else {
        console.log('[token---]', result.token);
        try {
          await toast.promise(
            chargeIdeaPledge(
              dbUser.id,
              pollId,
              select.id,
              result.token.id,
              +select.price.replace('$', '').replace(',', '.'),
              select.currency,
              coupon
            ),
            {
              loading: 'Charging...',
              success: 'Successfully',
              error: (err) =>
                err.error || err.message || 'Failed to charge pledge',
            }
          );
          setStatusObj({ ...statusObj, [select.id]: true });
          setSelect(undefined);
        } catch (err: any) {
          // console.log('failed to charge pledge', err);
          // toast.error(err?.message || 'Failed to charge pledge.');
        } finally {
          setSubmitting(false);
        }
      }
    }

    setSubmitting(false);
  };

  let bgColorBtnEditViewPoll = `${themeData.colors['detailPoll-btnViewEditPoll-color']}`;
  let borderColorBtnEditViewPoll = `${themeData.colors['detailPoll-btnViewEditPoll-borderColor']}`;
  let textColorBtnEditViewPoll = `${themeData.colors['detailPoll-btnViewEditPoll-textColor']}`;

  let bgColorBtnPledgeCastVote = `${themeData.colors['poll-btnPledgeCastVote-color']}`;
  let borderColorBtnPledgeCastVote = `${themeData.colors['poll-btnPledgeCastVote-borderColor']}`;
  let textColorBtnPledgeCastVote = `${themeData.colors['poll-btnPledgeCastVote-textColor']}`;

  let content;
  let leftContent;
  let header;
  if (data === 'NotFound') {
    header = (
      <div className="pt-32">
        <div className="flex flex-col items-center justify-center px-4 py-24 mx-4 text-center bg-white shadow-r-salmon-md">
          <h1 className="text-3xl sm:text-4xl">Idea is no longer available.</h1>
          <p>The idea has been deleted or this is an invalid idea.</p>

          <div className="mt-24">
            <img src={Logo} alt="migthypoll" />
          </div>
        </div>
      </div>
    );
  } else if (data === undefined) {
    header = (
      <div className="pt-64 text-white">
        <Loader spinnerCn="bg-white" title="Fetching Idea information..." />
      </div>
    );
  }
  //else if (auth !== true) {
  //   header = (
  //     <div className="pt-32">
  //       <div className="flex flex-col items-center justify-center px-4 py-24 mx-4 text-center bg-white shadow-r-salmon-md">
  //         <h1 className="text-3xl sm:text-4xl">Poll Password Protected</h1>
  //         <p>The poll is password protected, enter password to view.</p>

  //         <InputText
  //           className="max-w-sm mt-8"
  //           type="password"
  //           placeholder="Poll Password"
  //           value={password}
  //           onChange={(v) => {
  //             setPassword(v);
  //             setPasswordError(undefined);
  //           }}
  //         />
  //         {passwordError !== undefined && (
  //           <div className="flex justify-end px-2 mt-2 text-sm font-semibold text-red">
  //             {passwordError}
  //           </div>
  //         )}
  //         <div className="mt-8">
  //           <ButtonMighty
  //             color={bgColorBtnEditViewPoll}
  //             borderColor={borderColorBtnEditViewPoll}
  //             textColor={textColorBtnEditViewPoll}
  //             text="View Poll"
  //             margin="0"
  //             onClick={checkPassword}
  //           />
  //         </div>
  //       </div>
  //     </div>
  //   );
  else {
    header = (
      <div className="relative">
        <HeaderImage
          title={data?.title || ''}
          titleSize={(data?.title?.length || 0) > 15 ? 40 : 55}
          image={data?.image?.url || 'image'}
          alt="idea picture"
          pledge={true}
          edu={true}
        />
      </div>
    );
    leftContent = (
      <div>
        <div className="px-6" style={{ color: randomColors }}>
          Starts
        </div>
        <div className="text-white px-6">
          {format(data.startDate, 'dd LLL yyyy')}
        </div>
        <div className="text-white px-6">
          {format(data.startDate, 'hh.mm aa')}
        </div>
        <div className=" px-6 mt-4" style={{ color: randomColors }}>
          Ends
        </div>
        <div className="text-white px-6">
          {format(data.endDate, 'dd LLL yyyy')}
        </div>
        <div className="text-white px-6">
          {format(data.endDate, 'hh.mm aa')}
        </div>

        <PollShareCard neon={randomColors} pollId={pollId} isIdea={true} />

        {data?.endDate &&
          !isPast(data.endDate) &&
          isFuture(data?.endDate) &&
          ownerPermission && (
            <Link to={`/idea/${pollId}/edit`}>
              <ButtonMighty
                style={{ width: 300 }}
                neon={randomColors}
                color={bgColorBtnEditViewPoll}
                borderColor={borderColorBtnEditViewPoll}
                textColor={textColorBtnEditViewPoll}
                text="Edit Idea"
                margin="0"
              />
            </Link>
          )}
        {ownerPermission && (
          <ButtonMighty
            style={{ marginTop: 20, width: 300 }}
            neon={randomColors}
            color={bgColorBtnEditViewPoll}
            borderColor={borderColorBtnEditViewPoll}
            textColor={textColorBtnEditViewPoll}
            text="View Pledges"
            margin="0"
            onClick={() => {
              window.location.href = `/idea/${pollId}/pledge`;
            }}
          />
        )}

        {data?.owner && <hr className="my-8" />}
        {data?.owner && (
          <div
            className="flex justify-center text-center"
            style={{ color: 'white' }}
          >
            Created by <br />
            {data?.owner}
          </div>
        )}
      </div>
      // <div>
      //   <div className="px-4 bg-detailPoll-leftContent-bgColor lg:px-4 lg:mb-4 lg:mx-4 md:px-8">
      //     <div className="pt-8 pb-12">
      //       <div
      //         className="flex flex-col items-center space-y-4"
      //         style={!data ? { minHeight: 158 } : {}}
      //       >
      //         {data?.startDate && data?.endDate && (
      //           <PeriodTimeline
      //             title="Vote Period"
      //             active={
      //               data.startDate &&
      //               data.endDate &&
      //               isWithinInterval(new Date(), {
      //                 start: data.startDate,
      //                 end: data.endDate,
      //               })
      //             }
      //             start={data.startDate}
      //             end={data.endDate}
      //           />
      //         )}
      //       </div>
      //     </div>
      //     {(data.description || data.video) && (
      //       <div className="flex flex-col space-y-4">
      //         <h2 className="text-3xl ">
      //           <span className="inline-block px-2 py-1 bg-detailPoll-about-bgColor text-detailPoll-about-color">
      //             {data?.title}
      //           </span>
      //         </h2>
      //         {(data.description || data.video) && (
      //           <p
      //             className="text-base break-words whitespace-pre-wrap overflow-ellipsis text-detailPoll-about-desc-color"
      //             style={{
      //               hyphens: 'auto',
      //               paddingBottom: data.video ? 'calc(32px + 64px)' : 32,
      //             }}
      //           >
      //             {data.description}
      //           </p>
      //         )}
      //       </div>
      //     )}
      //   </div>
      //   <div className="flex-col hidden px-4 lg:flex">
      //     <PollShareCard pollId={pollId} isIdea={true} />
      //   </div>
      //   <div style={{ width: 'max-content', margin: '20px auto' }}>
      //     <ButtonMighty
      //       color={bgColorBtnEditViewPoll}
      //       borderColor={borderColorBtnEditViewPoll}
      //       textColor={textColorBtnEditViewPoll}
      //       text="View pledges"
      //       margin="0"
      //       onClick={() => {
      //         history.push('/idealist');
      //       }}
      //     />
      //   </div>
      // </div>
    );
    content = (
      <>
        <div style={{ backgroundColor: 'black', padding: 40 }}>
          <h1 className="text-4xl">
            <span className="inline-block px-2 py-1 text-white">
              About this Idea
            </span>
          </h1>
          <p style={{ marginTop: 10, color: randomColors }}>
            {data?.description}
          </p>

          {isPast(data.endDate) ? (
            // <h1 className="text-4xl" style={{ color: 'white', marginTop: 20 }}>
            //   Idea has ended
            // </h1>
            <div className="mt-2">
              {' '}
              <Notice title={`Idea has ended.`} />
            </div>
          ) : (
            <div>
              {data.video && (
                <div className="z-10 -mt-16 lg:mt-4">
                  <div className="flex items-center justify-center">
                    <Embed
                      className="z-20 w-full max-w-screen-sm mx-8 md:w-full shadow-l-magenta-lg"
                      style={{ maxHeight: 360 }}
                      src={data.video || ''}
                    />
                  </div>
                </div>
              )}
              {!!Object.keys(statusObj).length && (
                <div className="mt-2">
                  {' '}
                  <Notice
                    title={`Pledge accepted! The organiser will be in touch!`}
                  />
                </div>
              )}

              {data.pledges.items.map((item, index) => {
                let colorIx = index;
                while (colorIx >= COLORS.length) {
                  colorIx = colorIx - COLORS.length;
                }
                // if(getStatusPledge(item.ideaPledgeID)){
                //   return <p>aa</p>
                // }

                return (
                  <div
                    className="relative"
                    style={{ opacity: !statusObj[item.id] ? 1 : 0.3 }}
                  >
                    {!!statusObj[item.id] && (
                      <p
                        style={{
                          color: 'white',
                          position: 'absolute',
                          top: 5,
                          right: 10,
                        }}
                      >
                        Pledged
                      </p>
                    )}

                    <PollOptionCard
                      disabled={!!statusObj[item.id]}
                      neon={randomColors}
                      style={{ marginTop: 20 }}
                      color={COLORS[colorIx]}
                      key={`ideal-option-${item.id}`}
                      active={select?.id === item.id}
                      title={item.title || `Pledge ${index}`}
                      description={item.description || undefined}
                      price={item.price.replace('$', '') || undefined}
                      video={item.video || undefined}
                      // disabled={!selectable && !poll.isVotePeriod}
                      onClick={() => {
                        if (!!statusObj[item.id]) return;
                        setSelect(select?.id === item.id ? undefined : item);
                        // const index = select.findIndex((el) => el === item.id);
                        // const temp = [...select];
                        // if (index > -1) {
                        //   temp.splice(index, 1);
                        // } else {
                        //   const _id: string = item.id;
                        //   temp.unshift(_id);
                        // }
                        // setSelect(temp);
                      }}
                    />
                  </div>
                );
              })}
              <div className="mt-5">
                <InputText
                  value={coupon}
                  onChange={(e) => {
                    setCoupon(e);
                  }}
                  type="text"
                  neon={true}
                  style={{
                    borderRadius: 0,
                    marginTop: '32px',
                    borderWidth: 2,
                    marginBottom: '32px',
                    fontSize: '16px',

                    '::placeholder': {
                      color: '#aab7c4',
                    },
                    background: 'black',
                  }}
                  placeholder="Promo code"
                />

                <div
                  style={{
                    border: `2px solid ${randomColors}`,
                    height: '52px',
                    paddingTop: 15,
                    caretColor: 'red',
                  }}
                  className="px-2"
                >
                  {' '}
                  <CardElement
                    options={{
                      hidePostalCode: true,
                      style: {
                        base: {
                          fontSize: '16px',
                          color: 'white',
                          '::placeholder': {
                            color: '#aab7c4',
                          },
                        },

                        invalid: {
                          color: '#9e2146',
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div
                className="text-white py-4 my-4"
                style={{ marginBottom: 150 }}
              >
                {data?.comments?.items?.length ? (
                  <>
                    <p>What People Says...</p>
                    {checkScroll() && (
                      <img
                        src={ic_arr}
                        alt=""
                        style={{
                          width: 20,
                          height: 25,
                          margin: '20px auto',
                          transform: 'rotate(-90deg)',
                          cursor: 'pointer',
                        }}
                        onClick={() => scrollTo('top')}
                      />
                    )}

                    <div
                      className="w-full my-4"
                      id="scrollView1"
                      style={{ maxHeight: 350, overflow: 'auto' }}
                    >
                      {data.comments.items
                        .sort((a, b) => {
                          return (
                            +new Date(b.createdAt) - +new Date(a.createdAt)
                          );
                        })
                        .map((item) => (
                          <div className="my-4">
                            <div className="flex items-center justify-between">
                              <p style={{ color: randomColors }}>
                                {' '}
                                {item.name}
                              </p>
                              <p>
                                {format(
                                  +new Date(item?.createdAt) || 0,
                                  'dd MMM yyyy hh.mm aa'
                                )}
                              </p>
                            </div>
                            <p> {item.content}</p>
                          </div>
                        ))}
                    </div>
                    {checkScroll() && (
                      <img
                        src={ic_arr}
                        alt=""
                        style={{
                          width: 20,
                          height: 25,
                          margin: '20px auto',
                          transform: 'rotate(90deg)',
                          cursor: 'pointer',
                        }}
                        onClick={() => scrollTo('bottom')}
                      />
                    )}
                  </>
                ) : null}

                <div className="relative mt-4 pt-4">
                  <div
                    style={{
                      position: 'absolute',
                      bottom: -48,
                      right: 0,
                    }}
                  >
                    <ButtonMighty
                      color="#f97075"
                      neon={randomColors}
                      text={`Submit`}
                      loading={commenting}
                      disabled={commenting || !textComment.length}
                      style={commenting ? { background: randomColors } : {}}
                      onClick={() => comment()}
                      borderColor="#221f20"
                      margin="0"
                      textColor={randomColors}
                      width="auto"
                    />
                  </div>
                  <InputTextarea
                    limitMax
                    className="text-xl font-bold border-none"
                    placeholder={'This comments will be here'}
                    neon={randomColors}
                    value={textComment}
                    onKeyDown={(e) => {
                      console.log(e);
                      if (e.key === 'Enter' && !e.shiftKey) {
                        comment();
                      }
                    }}
                    onChange={(e) => setTextComment(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-full flex items-center justify-center mt-4">
                {/* <button
                  type="button"
                  style={{
                    marginBottom: 20,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    paddingLeft: 40,
                    paddingRight: 40,
                    border: 'solid 2px rgba(255, 70, 255,1)',
                  }}
                  className={
                    'mt-4  mx-auto py-2 text-lg font-bold text-magenta hover:bg-magenta hover:text-black  font-display  focus:outline-none '
                  }
                  onClick={(e) => pledges(e)}
                >
                  PLEDGE
                </button> */}
                <ButtonMighty
                  className="w-full xl:w-auto"
                  style={{ marginTop: 30 }}
                  neon={randomColors}
                  loading={isSubmitting}
                  color={bgColorBtnPledgeCastVote}
                  borderColor={borderColorBtnPledgeCastVote}
                  textColor={textColorBtnPledgeCastVote}
                  text="PLEDGE"
                  disabled={!select || isSubmitting}
                  margin="0"
                  onClick={(e) => pledges(e)}
                />
              </div>
              <div>
                <RadaChart />
              </div>
            </div>
          )}
        </div>

        {/* <PollOptionsForm
          withdrawUrl={`${url}/withdraw`}
          poll={data}
          stripe={
            <div>
              <Elements stripe={stripePromise}>
                <CardElement
                  options={{
                    hidePostalCode: true,
                    style: {
                      base: {
                        fontSize: '16px',
                        color: '#424770',
                        '::placeholder': {
                          color: '#aab7c4',
                        },
                      },
                      invalid: {
                        color: '#9e2146',
                      },
                    },
                  }}
                />
                <InputText
                  value={coupon}
                  onChange={(e) => {
                    setCoupon(e);
                  }}
                  type="text"
                  style={{
                    marginTop: '32px',
                    fontSize: '16px',
                    color: '#424770',
                    '::placeholder': {
                      color: '#aab7c4',
                    },
                    background: 'black',
                  }}
                  placeholder="Promo code"
                />
              </Elements>
            </div>
          }
          selected={{}}
        /> */}

        {/* {data && (
          <div className="poll-detail-votes">
            <div>{voteCount}</div>
            <div>Total Number of Votes</div>
          </div>
        )} */}

        <div className="px-4 lg:hidden">
          <PollShareCard pollId={pollId} />
        </div>

        {/* <div className="mt-8 text-center underline text-detailPoll-reportLink-color">
          <Link to={`/poll/${pollId}/report`}>
            <span className="p-4">Report Poll</span>
          </Link>
        </div> */}

        {/* {data.endDate && isFuture(data.endDate) && ownerPermission && (
          <div className="mx-4 mt-8 lg:hidden">
            <Link to={`/poll/${pollId}/edit`}>
              <ButtonMighty
                color={bgColorBtnEditViewPoll}
                borderColor={borderColorBtnEditViewPoll}
                textColor={textColorBtnEditViewPoll}
                text="Edit Poll"
                margin="0"
              />
            </Link>
          </div>
        )} */}

        {/* {data.pledgePeriod1StartDate &&
          isPast(data.pledgePeriod1StartDate) &&
          ownerPermission && (
            <div className="mx-4 mt-8 lg:hidden">
              <Link to={`/poll/${pollId}/pledges`}>
                <ButtonMighty
                  color={bgColorBtnPledgeCastVote}
                  borderColor={borderColorBtnPledgeCastVote}
                  textColor={textColorBtnPledgeCastVote}
                  text="View Pledges"
                  margin="0"
                />
              </Link>
            </div>
          )} */}
      </>
    );
  }

  return (
    <div
      id="ok2"
      className={`h-screen overflow-x-hidden overflow-y-scroll bg-fixed bg-black`}
    >
      {header}
      <div className="flex flex-col gap-4 mx-auto lg:container xl:gap-4 lg:flex-row">
        <div
          className="w-full my-4 lg:min-h-screen lg:sticky lg:top-0"
          style={{ maxWidth: 350 }}
        >
          {leftContent}
        </div>
        <div className="flex flex-1">
          <div className="flex-1 pb-24 md:pb-64 lg:pb-32 lg:mr-4 lg:pt-4">
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

// export default PollDetailPage;

const stripePromise1 = loadStripe(
  process.env.REACT_APP_STRIPE_PUB_KEY ||
    'pk_test_51Iffk1IXx2HzzlEOIl2w2tJmhcSXOuitzV7SAkJaqi3aqRKOcOi2ElHYBR5YRT1ESJv4NsKvhTYBNSPnYEPcdQ6G00MG5sbPSM'
);

const WrappedPledgeIdeaCheckoutForm: React.FC<any> = (props) => {
  return (
    <Elements stripe={stripePromise1}>
      <PollDetailPage {...props} />
    </Elements>
  );
};

export default WrappedPledgeIdeaCheckoutForm;
